var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    transform: "matrix(-1 0 0 1 13 6)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.25H17.25C20.9719 5.25 24 8.27812 24 12C24 15.7219 20.9719 18.75 17.25 18.75H6.75C3.02813 18.75 0 15.7219 0 12C0 8.27812 3.02813 5.25 6.75 5.25ZM6.75 17.25C7.78835 17.25 8.80339 16.9421 9.66674 16.3652C10.5301 15.7883 11.203 14.9684 11.6004 14.0091C11.9977 13.0498 12.1017 11.9942 11.8991 10.9758C11.6966 9.95738 11.1965 9.02192 10.4623 8.28769C9.72808 7.55346 8.79263 7.05345 7.77423 6.85088C6.75583 6.64831 5.70022 6.75227 4.74091 7.14963C3.7816 7.54699 2.96166 8.2199 2.38478 9.08326C1.80791 9.94661 1.5 10.9616 1.5 12C1.50149 13.3919 2.05509 14.7264 3.03933 15.7107C4.02358 16.6949 5.35807 17.2485 6.75 17.25Z",
    fill: "#657397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonToggle);
export default __webpack_public_path__ + "static/media/ion_toggle.eeaff9ff06d18fef8ef3a8ed316516f4.svg";
export { ForwardRef as ReactComponent };